import { Component, OnInit, Input, Output, EventEmitter, Inject, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatButtonModule, MatDialog, MatDialogModule, MatDialogRef, MatFormFieldModule, MatInputModule } from '@angular/material';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DialogoSiNoComponent } from './dialogo-si-no/dialogo-si-no.component';
import { DialogoConfirmacionComponent } from './dialogo-confirmacion/dialogo-confirmacion.component';
import { DBasicosParametricasServicios, DValorDominio } from '@dian/api-basicos-parametricas';

export interface TableHeader {
  id: string;
  title: string;
}

const POLITICA_1654 = "1654";
@Component({
  selector: 'app-table-items',
  templateUrl: './table-items.component.html',
  styleUrls: ['./table-items.component.css'],
  providers: [
    DBasicosParametricasServicios,
  ]
})
export class TableItemsComponent implements OnInit {

  @Input('header') header: TableHeader[] = [];
  @Input('body') body: any[] = [];
  @Input('withOptions') withOptions: boolean = true;
  @Input('total') total: number = 0;
  @Input('mostrarTotal') mostrarTotal: boolean = true;

  @Input('showAddButton') showAddButton: boolean = true;//funcionalidad ocultar botón agregar
  @Input('columnPesos') columnPesos: string[] = [];//funcionalidad mostrar en columna signo pesos
  @Output('event') event: EventEmitter<string> = new EventEmitter<string>();
  @Output('itemSelected') itemSelected: EventEmitter<any> = new EventEmitter<any>();

  itemsOrigen: DValorDominio[] = [];
  infoOrigenCargada = false;
  
  constructor(
    private dBasicosParametricasServicios: DBasicosParametricasServicios,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.obtenerValorDominio1654();

    if (this.withOptions) {
      const opExist = this.header.some(item => item.id === 'op');
      if (!opExist) this.header.push({ id: 'op', title: 'Acciones' });
    }
  }

  //Valor dominio 1654
  private obtenerValorDominio1654(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1654, null, null, null, "codigo", "asc").subscribe(
      data => {
        this.itemsOrigen = <Array<DValorDominio>>data
        this.infoOrigenCargada = true;
      },
      error => {
        this.infoOrigenCargada = true;
        console.error(error)
      }
    )

  }

  editItem(index: number) {

    if (this.body[index].origen == '0') {
      const dialogRef = this.dialog.open(DialogoConfirmacionComponent, {
        data: {
          mensaje1: '¿Quiere editar la información original?',
          mensaje2: 'Estos cambios son bajo su criterio y responsabilidad.',
          botonTrue: 'Editar',
          botonFalse: 'Mantener información'
        }
      });
      dialogRef
        .afterClosed().subscribe(res => {
          if (!res) return;
          this.event.emit('edit');
          this.itemSelected.emit(index);
        });
    } else {
      this.event.emit('edit');
      this.itemSelected.emit(index);
    }


  }

  deleteItem(index: number) {
    //                                                     :string,:string,
    // this.dNotificacionServicio.mostrarDialogoSiNo(
    //   '¿Está seguro de eliminar esta información?',//title?
    //   'Al hacerlo no podrá recuperarla.',//mensaje?
    //   '',//mensajeDetallado?:string, 
    //   '',//colorToolbar?: string, 
    //   '#41d78c',//colorButtonConfirm?: string, 
    //   '#262944',//colorTextButtonConfirm?: string
    //   '#ffffff',//colorButtonCancel?: string, 
    //   '#262944'//colorTextButtonCancel?: string
    //   )

    const dialogRef = this.dialog.open(DialogoConfirmacionComponent, {
      data: {
        mensaje1: '¿Desea eliminar este ítem?',
        mensaje2: 'Estos cambios son bajo su criterio y responsabilidad.',
        botonTrue: 'Si, eliminar',
        botonFalse: 'No, mantener información'
      }
    });

    dialogRef
      .afterClosed().subscribe(res => {
        if (!res) return;
        this.body.splice(index, 1);
        this.event.emit('delete');
        this.itemSelected.emit(index);
      });
  }

  agregarSignoPesos(nombreColumna: string): boolean {
    return this.columnPesos.includes(nombreColumna);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/table-items/table-items.component.ts